// The Meta Pixel loader (fbevents.js) for the Photohawk Studio pixel (lib/studioPixel.ts): the same standard snippet
// as the photographer's own gallery pixel (lib/gallery/pixel.ts, left as it is), and both reuse a loaded `window.fbq`.
// Callers load it only after the visitor's analytics/advertising consent (lib/consent.ts). Client-only; no-op on SSR.

export type Fbq = ((...args: unknown[]) => void) & Record<string, unknown>;

/** Load the fbevents.js snippet once (no-op after the first call / on SSR). */
export const ensureFbq = (): Fbq | null => {
  if (typeof window === "undefined" || typeof document === "undefined") return null;
  const w = window as unknown as { fbq?: Fbq; _fbq?: Fbq };
  if (w.fbq) return w.fbq;

  const fbq = function (this: unknown, ...args: unknown[]) {
    const self = fbq as Fbq;
    if (typeof self.callMethod === "function") (self.callMethod as (...a: unknown[]) => void)(...args);
    else (self.queue as unknown[]).push(args);
  } as Fbq;
  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = "2.0";
  w.fbq = fbq;
  w._fbq = fbq;

  const s = document.createElement("script");
  s.async = true;
  s.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(s);
  return fbq;
};
